
import {
    Component,
    Vue,
    Inject,
    Prop,
    Watch
} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase';
import PageRequest from '@/store/entities/page-request';
import Ajax from '@/lib/ajax';
import axios from 'axios'
class PagenoticeRequest extends PageRequest {
    memoFilter: string;
    MaxuserIdFilter: number;
    MinuserIdFilter: number;
}
class Abnormal {
    actualName: string;
    imei: string;
    high: string;
    low: string;
    to_time: any;
    from_time: any;
    count: any;
    highLowFlag: string;
    advice: string;
    heartFlag: string;
    spo2Flag: string;
    spo2: string;
    time: any;
}
@Component
export default class Reminder extends AbpBase {
    @Prop({
        type: Number,
        default: 0
    }) Count: number;

    toReminder(){
        this.$router.push('/reminder/index')
    }
}
